import { useState } from "react";

interface Option {
  id: string;
  label: string;
  hint?: string;
}

/**
 * Rendered when the coach calls present_choice. Clicking a button sends the
 * chosen label as a fresh user message; once any option is picked the whole
 * group is locked so the user can't double-fire and the history reads cleanly.
 */
export function ChoiceButtons(props: {
  toolCallId: string;
  question: string;
  options: Option[];
  onPick: (label: string) => void;
}) {
  const [pickedId, setPickedId] = useState<string | null>(null);
  const locked = pickedId !== null;

  return (
    <div className="space-y-2">
      {props.question && (
        <div className="text-sm leading-relaxed">{props.question}</div>
      )}
      <div className="flex flex-wrap gap-2 pt-1">
        {props.options.map((o) => {
          const isPicked = o.id === pickedId;
          return (
            <button
              key={o.id}
              disabled={locked}
              onClick={() => {
                setPickedId(o.id);
                props.onPick(o.label);
              }}
              className={
                "rounded-2xl border px-3.5 py-2 text-left text-sm transition disabled:cursor-not-allowed " +
                (isPicked
                  ? "border-neutral-900 bg-neutral-900 text-white"
                  : locked
                    ? "border-neutral-200 bg-neutral-50 text-neutral-400"
                    : "border-neutral-300 bg-white text-neutral-900 hover:border-neutral-500")
              }
            >
              <div className="font-medium">{o.label}</div>
              {o.hint && (
                <div
                  className={`mt-0.5 text-[11px] ${
                    isPicked ? "text-neutral-300" : "text-neutral-500"
                  }`}
                >
                  {o.hint}
                </div>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
}
